/* State / City filter picked from pincode_master (GET geo/states, geo/cities?state=), never typed, so the filter does
   not depend on how a city or state was spelt on an order. The page resolves the pick to its pincodes
   (GET geo/pincodes) and filters the delivery pincode with them. Only use it where that pincode query is indexed
   (today the PTL Non-ABD list, which rides the abd_baseline index).
   Form values: `state` and `city` hold the master's name (option.value). */
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { Autocomplete, TextField } from '@mui/material'
import { useGeoCitiesQuery, useGeoStatesQuery } from '../redux/ptlNabdApiSlice'

const MAX_SHOWN = 200

/** Matches the label, ignoring case. */
function filterOptions(options, { inputValue }) {
  const q = (inputValue || '').trim().toLowerCase()
  const out = []
  for (const o of options) {
    if (!q || o.label.toLowerCase().includes(q)) out.push(o)
    if (out.length >= MAX_SHOWN) break
  }
  return out
}

function GeoSelect({ name, options, loading, failed, placeholder, onPicked }) {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Autocomplete
          size='small'
          fullWidth
          options={options}
          loading={loading}
          noOptionsText={failed ? 'Could not load the list. Refresh the page or try again later.' : 'No match'}
          value={options.find((o) => o.value === value) || null}
          onChange={(_e, o) => { onChange(o ? o.value : ''); if (onPicked) onPicked(o) }}
          isOptionEqualToValue={(a, b) => a.value === b.value}
          getOptionLabel={(o) => o.label}
          filterOptions={filterOptions}
          renderOption={(props, o) => <li {...props} key={o.value}>{o.label}</li>}
          renderInput={(p) => <TextField {...p} placeholder={placeholder} />}
        />
      )}
    />
  )
}

export function GeoStateFilter() {
  const { setValue } = useFormContext()
  const { data = [], isFetching, isError } = useGeoStatesQuery()
  // a new state invalidates the picked city
  return <GeoSelect name='state' options={data} loading={isFetching} failed={isError} placeholder='All states' onPicked={() => setValue('city', '')} />
}

export function GeoCityFilter() {
  const state = useWatch({ name: 'state' })
  const { data = [], isFetching, isError } = useGeoCitiesQuery(state || '')
  return <GeoSelect name='city' options={data} loading={isFetching} failed={isError} placeholder={state ? 'All cities in the state' : 'All cities'} />
}
